<script lang="ts">
    import { onMount } from "svelte";
    import Btn from "../../components/Btn.svelte";
    import Container from "../../components/Container.svelte";
    import Headline from "../../components/Headline.svelte";
    import Hero from "../../components/Hero.svelte";
    import LightTheme from "../../components/LightTheme.svelte";
    import Subline from "../../components/Subline.svelte";
    import Cookies from "js-cookie";
    import { Loader, LoaderOptions } from "google-maps";
    import { each } from "svelte/internal";
    import MapIcon from "../../icons/MapIcon.svelte";
    import IconImg from "../../components/IconImg.svelte";
    import Divider from "../../components/Divider.svelte";
    import Gap from "../../components/Gap.svelte";
    import mapstyle from "./mapstyle";
    import Animate from "../../components/Animate.svelte";
    import ButtonRow from "../../components/ButtonRow.svelte";
    import { t } from "../../helpers/translation";

    type Ansprechpartner = {
        name: string;
        headline?: string;
        street: string;
        city: string;
        ansprechpartner?: string;
        ansprechpartner_work?: string;
        tel?: string;
        mail?: string;
        color?: string;
        dividerHeadline?: string;
    };
    let partners: Ansprechpartner[] = [];
    $: partners = [
        // {
        //     dividerHeadline: $t("page.contact.locations.1.dividerheadline"),
        //     headline: $t("page.contact.locations.1.headline"),
        //     name: $t("page.contact.locations.1.name"),
        //     street: $t("page.contact.locations.1.street"),
        //     city: $t("page.contact.locations.1.city"),
        //     ansprechpartner: $t("page.contact.locations.1.ansprechpartner"),
        //     ansprechpartner_work: $t(
        //         "page.contact.locations.1.ansprechpartner_work",
        //     ),
        //     tel: $t("page.contact.locations.1.tel"),
        //     mail: $t("page.contact.locations.1.mail"),
        //     color: $t("page.contact.locations.1.color"),
        // },
        {
            dividerHeadline: $t("page.contact.locations.2.dividerheadline"),
            headline: $t("page.contact.locations.2.headline"),
            name: $t("page.contact.locations.2.name"),
            street: $t("page.contact.locations.2.street"),
            city: $t("page.contact.locations.2.city"),
            ansprechpartner: $t("page.contact.locations.2.ansprechpartner"),
            ansprechpartner_work: $t(
                "page.contact.locations.2.ansprechpartner_work",
            ),
            tel: $t("page.contact.locations.2.tel"),
            mail: $t("page.contact.locations.2.mail"),
            color: $t("page.contact.locations.2.color"),
        },
        {
            dividerHeadline: $t("page.contact.locations.3.dividerheadline"),
            headline: $t("page.contact.locations.3.headline"),
            name: $t("page.contact.locations.3.name"),
            street: $t("page.contact.locations.3.street"),
            city: $t("page.contact.locations.3.city"),
            ansprechpartner: $t("page.contact.locations.3.ansprechpartner"),
            ansprechpartner_work: $t(
                "page.contact.locations.3.ansprechpartner_work",
            ),
            tel: $t("page.contact.locations.3.tel"),
            mail: $t("page.contact.locations.3.mail"),
            color: $t("page.contact.locations.3.color"),
        },
        {
            dividerHeadline: $t("page.contact.locations.4.dividerheadline"),
            headline: $t("page.contact.locations.4.headline"),
            name: $t("page.contact.locations.4.name"),
            street: $t("page.contact.locations.4.street"),
            city: $t("page.contact.locations.4.city"),
            ansprechpartner: $t("page.contact.locations.4.ansprechpartner"),
            ansprechpartner_work: $t(
                "page.contact.locations.4.ansprechpartner_work",
            ),
            tel: $t("page.contact.locations.4.tel"),
            mail: $t("page.contact.locations.4.mail"),
            color: $t("page.contact.locations.4.color"),
        },
        {
            dividerHeadline: $t("page.contact.locations.6.dividerheadline"),
            headline: $t("page.contact.locations.6.headline"),
            name: $t("page.contact.locations.6.name"),
            street: $t("page.contact.locations.6.street"),
            city: $t("page.contact.locations.6.city"),
            ansprechpartner: $t("page.contact.locations.6.ansprechpartner"),
            ansprechpartner_work: $t(
                "page.contact.locations.6.ansprechpartner_work",
            ),
            tel: $t("page.contact.locations.6.tel"),
            mail: $t("page.contact.locations.6.mail"),
            color: $t("page.contact.locations.6.color"),
        },
        {
            dividerHeadline: $t("page.contact.locations.5.dividerheadline"),
            headline: $t("page.contact.locations.5.headline"),
            name: $t("page.contact.locations.5.name"),
            street: $t("page.contact.locations.5.street"),
            city: $t("page.contact.locations.5.city"),
            ansprechpartner: $t("page.contact.locations.5.ansprechpartner"),
            ansprechpartner_work: $t(
                "page.contact.locations.5.ansprechpartner_work",
            ),
            // tel: $t("page.contact.locations.5.tel"),
            mail: $t("page.contact.locations.5.mail"),
            color: $t("page.contact.locations.5.color"),
        },
    ];
</script>

<LightTheme />

<Hero headline={$t("page.locations.hero.headline")} small gray />

<Container max="800px">
    <Headline>
        {@html $t("page.locations.headline")}
    </Headline>
    <Subline>
        {@html $t("page.locations.subline")}
    </Subline>
    <div id="scroll-map" />
</Container>

<Container>
    <div class="contact-infos">
        <div class="infos">
            <div class="partners">
                {#each partners as partner}
                    {#if partner.dividerHeadline}
                        <h2>{partner.dividerHeadline}</h2>
                    {/if}
                    <div class="partner" style="--color: var({partner.color})">
                        <h4>{partner.name}</h4>
                        {#if partner.headline}
                            <h4>{partner.headline}</h4>
                        {/if}
                        <p>
                            {partner.ansprechpartner} <br />
                            {partner.ansprechpartner_work} <br />
                            {#if partner.tel}
                                {$t("page.contact.form.field.phone")}:
                                <a href="tel:{partner.tel}">{partner.tel}</a>
                                <br />
                            {/if}
                            {$t("page.contact.form.field.email")}:
                            <a href="mailto:{partner.mail}">{partner.mail}</a>
                            <br />
                            {partner.street} <br />
                            {partner.city} <br />
                        </p>
                    </div>
                {/each}
            </div>
        </div>
        <div class="map">
            <img
                src="https://liveicom.azureedge.net/sinus/img/sinus-map-v2.svg"
                alt="map"
            />
        </div>
    </div>
</Container>

<Container max="800px">
    <Gap height="6rem" />
    <Subline>
        {@html $t("page.locations.joinus.headline")}
    </Subline>
    <p>
        {@html $t("page.locations.joinus.p")}
    </p>
    <ButtonRow>
        <Btn href="karriere" arrow>
            {@html $t("page.locations.joinus.btn.tojobs")}
        </Btn>
        <Btn href="aktuelles/termine" arrow yellow>
            {@html $t("page.locations.joinus.btn.termine")}
        </Btn>
    </ButtonRow>
</Container>

<style lang="scss">
    @import "../../vars";

    .contact-infos {
        display: grid;
        grid-template-columns: 1fr 2fr;
        gap: 1rem;

        @media (max-width: 600px) {
            grid-template-columns: 1fr;
        }

        --color: var(--green);

        .partner {
            border-left: 1rem solid var(--color);
            padding-left: 1rem;
            h4 {
                margin: 0em !important;
            }
            p {
                margin-top: 0.5em;
                font-size: 1rem;
                line-height: 1.3em;
            }
            a {
                color: var(--grayDark2);
            }
        }
    }
</style>
